import { FileImageOutlined } from '@ant-design/icons';
import Button from 'app/atoms/Button';

const EmptyState = ({ onCreate }: { onCreate: () => void }) => (
  <div className="flex flex-col items-center justify-center py-16 bg-white rounded-lg border">
    <FileImageOutlined className="text-6xl text-[#D4380D] mb-4" />
    <h2 className="text-2xl font-semibold mb-2 font-figtree">No onboarding screens yet</h2>
    <p className="text-gray-500 mb-4 font-figtree">Create the first screen shown to Urban Mobility app users.</p>
    <Button variant="primary" onClick={onCreate}>
      Create screen
    </Button>
  </div>
);

export default EmptyState;
